"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Workflows API
 * Create and manage pipelines
 *
 * The version of the OpenAPI document: 1.2.0
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
function ReqBaseTaskFromJSON(json) {
    return ReqBaseTaskFromJSONTyped(json, false);
}
exports.ReqBaseTaskFromJSON = ReqBaseTaskFromJSON;
function ReqBaseTaskFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': _1.EnumTaskTypeFromJSON(json['type']),
        'depends_on': !runtime_1.exists(json, 'depends_on') ? undefined : (json['depends_on'].map(_1.TaskDependencyFromJSON)),
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'execution_profile': !runtime_1.exists(json, 'execution_profile') ? undefined : _1.ExecutionProfileFromJSON(json['execution_profile']),
        'input': !runtime_1.exists(json, 'input') ? undefined : json['input'],
        'output': !runtime_1.exists(json, 'output') ? undefined : json['output'],
    };
}
exports.ReqBaseTaskFromJSONTyped = ReqBaseTaskFromJSONTyped;
function ReqBaseTaskToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': _1.EnumTaskTypeToJSON(value.type),
        'depends_on': value.depends_on === undefined ? undefined : (value.depends_on.map(_1.TaskDependencyToJSON)),
        'description': value.description,
        'execution_profile': _1.ExecutionProfileToJSON(value.execution_profile),
        'input': value.input,
        'output': value.output,
    };
}
exports.ReqBaseTaskToJSON = ReqBaseTaskToJSON;
